import { AdminAPI } from "../../helper/API/API.base";
import { getHeaders } from "../../helper/API/API.header";
import { ErrorToast, SuccessToast } from "../../helper/Toast";
import { toastMessage } from "../../helper/config/toastMessage.config";
import {
  LIST_ALL_LENSES_TYPES_REQUEST,
  LIST_ALL_LENSES_TYPES_SUCCESS,
  LIST_ALL_LENSES_TYPES_FAILURE,
  UPDATE_LENSES_TYPE_SUCCESS,
  DELETE_LENSES_TYPE_SUCCESS,
  CREATE_LENSES_TYPE_SUCCESS,
} from "../constants/lensesType";

export const listAllLensesTypes = () => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      dispatch({ type: LIST_ALL_LENSES_TYPES_REQUEST });

      // header
      const headers = await getHeaders();

      // API
      const response = await AdminAPI.get("/lenses-type", { headers });

      const lensesList = [];
      response?.data?.forEach((x) => {
        lensesList.push({
          id: x._id,
          lenses_type: x.lenses_type,
          description: x.description,
          price: x.price,
          colors: x.colors,
          is_active: x.is_active,
        });
      });

      dispatch({
        type: LIST_ALL_LENSES_TYPES_SUCCESS,
        payload: lensesList,
      });

      resolve(response);
    } catch (error) {
      dispatch({
        type: LIST_ALL_LENSES_TYPES_FAILURE,
        payload: error?.message,
      });

      // if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      // else 
      if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};

export const updateLenseType = (values, lenseTypeId) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getHeaders();

      // AXIOS BODY
      const body = values;

      // API
      const response = await AdminAPI.put(`/lenses-type/${lenseTypeId}`, body, {
        headers,
      });

      dispatch({
        type: UPDATE_LENSES_TYPE_SUCCESS,
        payload: response?.data,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Lense type updated successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {
      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};

export const deleteLenseType = (values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getHeaders();

      // AXIOS BODY
      const lenseTypeId = values.id;

      // API
      const response = await AdminAPI.delete(`/lenses-type/${lenseTypeId}`, { headers });

      dispatch({
        type: DELETE_LENSES_TYPE_SUCCESS,
        payload: lenseTypeId,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Lense type deleted successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {

      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};

export const createLenseType = (values) => (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const headers = await getHeaders();

      // AXIOS BODY
      const body = values;

      // API
      const response = await AdminAPI.post(`/lenses-type`, body, { headers });

      dispatch({
        type: CREATE_LENSES_TYPE_SUCCESS,
        payload: response?.data,
      });

      if (response?.data?.message?.status === 200) {
        SuccessToast("Lense type added successfully!");
      } else if (response?.data?.res?.status === 500) {
        ErrorToast(response?.data?.res?.message);
      }
      resolve(response);
    } catch (error) {

      if (error) ErrorToast(toastMessage?.ERROR_TRY_AGAIN);
      else if (error?.message === "Network Error") ErrorToast(toastMessage?.NETWORK_ERROR);
      else return;

      reject(error);
    }
  }).catch((catchError) => {
    throw new Error(catchError)
  });
};
